import type { CouponRuntimeStatus, HomepageCouponConfig } from './types';

const ACTIVE_STATUS = 1;
const CAN_CLAIM_STATUS = 1;
const VISIBLE_TO_VISITOR = 1;
const PLAIN_NUMBER_PATTERN = /^\d+(?:\.\d+)?$/;

function isRuntimeCouponAvailable(coupon: CouponRuntimeStatus, isLoggedIn: boolean): boolean {
  if (coupon.status !== undefined && Number(coupon.status) !== ACTIVE_STATUS) return false;
  if (coupon.code_status !== undefined && Number(coupon.code_status) !== ACTIVE_STATUS)
    return false;

  return !isLoggedIn || Number(coupon.is_get) === CAN_CLAIM_STATUS;
}

/**
 * 保持装修顺序，从接口当前仍有效的券中取第一张可透出的券。
 */
export function selectHomepageCoupon(
  configuredCoupons: HomepageCouponConfig[],
  runtimeCoupons: CouponRuntimeStatus[],
  isLoggedIn: boolean,
): HomepageCouponConfig | null {
  const runtimeById = new Map(runtimeCoupons.map((coupon) => [Number(coupon.id), coupon] as const));

  for (const configuredCoupon of configuredCoupons) {
    if (!isLoggedIn && Number(configuredCoupon.visitor_visible) !== VISIBLE_TO_VISITOR) continue;

    const runtimeCoupon = runtimeById.get(Number(configuredCoupon.coupon_id));
    if (!runtimeCoupon || !isRuntimeCouponAvailable(runtimeCoupon, isLoggedIn)) continue;

    return configuredCoupon;
  }

  return null;
}

export function formatCouponAmount(
  amount: string | null | undefined,
  symbolPrefix = '$',
  symbolSuffix = '',
): string {
  const normalizedAmount = amount?.trim();
  if (!normalizedAmount) return '';

  if (!PLAIN_NUMBER_PATTERN.test(normalizedAmount)) return normalizedAmount;
  return `${symbolPrefix}${normalizedAmount}${symbolSuffix}`;
}

/**
 * 从实际可领取券规则中解析券面优惠值。
 * 魔方的 discount_amount 是完整规则描述，不能作为金额字段直接渲染。
 */
export function resolveCouponAmount(runtimeCoupon: CouponRuntimeStatus | undefined): string {
  if (!runtimeCoupon) return '';

  const way = Number(runtimeCoupon.way);
  if (way === 4) return 'FREE';

  if (way === 1 || way === 5) {
    const value = runtimeCoupon.discounts_details?.discounts_value;
    return value ? `${value}%` : '';
  }

  if (way === 2) return runtimeCoupon.full_discounts_details?.discounts_value || '';
  if (way === 3) return runtimeCoupon.appoint_discounts_details?.discounts_value || '';

  return '';
}
